<template>
<div
  class="sidebar-item"
  :class="{
    'sidebar-item--children-expanded': childrenExpanded,
    'sidebar-item--force-highlight': forceHighlight,
  }"
>
  <router-link
    v-if="!hasChildren"
    @click.native="setSidebarState(false)"
    :to="getCategoryRoute(category)"
    class="sidebar-item__background"
  >{{ category.name }}</router-link>
  <template v-else>
    <button
      :aria-labelledby="textLinkId"
      @click="$emit('click:expand')"
      class="sidebar-item__background absolute"
    />
    <!-- Can set `tabindex="-1"` because the same link is available in the popup. -->
    <router-link
      :to="getCategoryRoute(category)"
      class="sidebar-item__text-link"
      :id="textLinkId"
      tabindex="-1"
    >{{ category.name }}</router-link>
    <button
      type="button"
      @click="$emit('click:expand')"
      class="sidebar-item__expand-button"
      tabindex="-1"
    >
      <i class="sidebar-item__expand-button-icon fa fa-xs fa-chevron-right"/>
    </button>
  </template>
</div>
</template>

<script>
import { mapMutations } from 'vuex';
import getCategoryRoute from '../getCategoryRoute';

export default {
  props: {
    category: {
      required: true,
      type: Object,
    },
    childrenExpanded: {
      type: Boolean,
    },
    forceHighlight: {
      type: Boolean,
    },
  },
  computed: {
    hasChildren() {
      return this.category.children?.length > 0;
    },
    textLinkId() {
      return Math.random();
    },
  },
  methods: {
    ...mapMutations({
      setSidebarState: "ui/setSidebarState"
    }),
    getCategoryRoute,
  },
};
</script>

<style lang="less">
@r: sidebar-item;
.@{r} {
  @apply relative text-sm
    flex
    justify-between;
  color: theme('colors.sidebar-text');
  @item-padding-x: theme('padding.2');
  @item-padding: theme('padding.2') @item-padding-x;
  @border-left-width: theme('borderWidth.4');
  .highlight() {
    @apply border-primary-lighter bg-secondary-lightest;
  }
  &--children-expanded {
    .@{r} {
      &__expand-button-icon {
        @apply text-primary;
        transform: rotate(90deg);
      }
      &__background {
        .highlight();
      }
    }
  }
  &--force-highlight {
    .@{r} {
      &__background {
        .highlight();
      }
    }
  }
  &__background {
    @apply w-full h-full border-transparent border-solid;
    border-left-width: @border-left-width;
    padding: @item-padding;
    transition:
      background-color .1s ease-in,
      border-color .1s ease-in;
    &:hover,
    .@{r}:hover &,
    &:focus {
      @apply outline-none border-primary-light bg-secondary-lighter;
    }
    &.router-link-active,
    .@{r}:hover &.router-link-active {
      @apply border-primary bg-secondary-light;
    }
  }
  &__text-link {
    @apply block
      relative; // So it is on top of the background.
    margin: @item-padding;
    margin-left: calc(@border-left-width + @item-padding-x);
    &:hover, &:focus {
      @apply text-primary outline-none;
    }
  }
  &__expand-button {
    @apply px-3 text-dark-lighter
      relative; // So it is on top of the background.
    &:focus {
      @apply outline-none;
    }
  }
  &__expand-button-icon {
    transition:
      transform 0.15s,
      color 0.08s;
  }
}
</style>
